module.exports = __webpack_public_path__ + "img/nav-dianti.716aaeb9.png";